const {loadScript, loadStyle} = require('./util/loadDependencies');



export default () => jQuery(($) => {
	const doDateFormat = () => {
		setTimeout(function(){
			var date_fields = $('.duet-date__input');
			date_fields.attr('placeholder', 'MM/DD/YYYY');
			date_fields.blur(function () {
				const fieldValue = $('input[name="' + $(this).attr('id') + '"]').val();
				if (fieldValue) {
					$(this).val(
						formatFormDateObj(
							new Date(fieldValue)
						)
					);
				} else {
					$(this).val('');
				}
			});
		}, 750);
	};

	const formatFormDateText = date => {
		const dateArray = date.trim().split(/[\/\-. ]/);
		if (dateArray && dateArray.length === 1 && date.trim().length === 8) {
			const dateMatches = date.trim().match(/^(\d{2})(\d{2})(\d{4})$/);
			return `${dateMatches[1]}/${dateMatches[2]}/${dateMatches[3]}`;
		} else if (dateArray && dateArray.length === 3) {
			return `${dateArray[0]}/${dateArray[1]}/${dateArray[2]}`;
		}

		return date;
	};
	const formatFormDateObj = date => {
		return `${date.getUTCMonth() < 9 ? '0' : ''}${date.getUTCMonth() + 1}/${date.getUTCDate() < 10 ? '0' : ''}${date.getUTCDate()}/${date.getUTCFullYear()}`;
	};

	const triggerDatePicker = () => {
		const datePicker = document.querySelectorAll('duet-date-picker');

		datePicker.forEach(function(dateElement){
			dateElement.dateAdapter = {
				parse(value = "", createDate) {
					const fieldDateFormatted = formatFormDateText(value);
					if (fieldDateFormatted && fieldDateFormatted.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)) {
						const dateArray = fieldDateFormatted.split('/');
						return createDate(dateArray[2], dateArray[0], dateArray[1]);
					}
				},
				format(date) {
					return formatFormDateObj(date);
				},
			}
		})
	};

	doDateFormat();

	loadStyle('https://cdn.jsdelivr.net/npm/@duetds/date-picker@1.3.0/dist/duet/themes/default.css');
	loadScript('https://cdn.jsdelivr.net/npm/@duetds/date-picker@1.3.0/dist/duet/duet.esm.js', 'void', 'module');
	loadScript('https://cdn.jsdelivr.net/npm/@duetds/date-picker@1.3.0/dist/duet/duet.js', triggerDatePicker, null, [{
		attr: 'nomodule',
		value: 'nomodule'
	}]);

	$(document).on('click', 'a', ()=>{
		setTimeout(()=>{
			doDateFormat();
			triggerDatePicker();
		}, 750)

	}); // for when form elements are added

});
